import { z } from 'zod';

import { AlgoliaFacet } from '@jane/bloom/types/schemas/algolia/facets';

export const SortOrderSchema = z.enum(['rating', 'recent', 'upvote']);
export type SortOrder = z.infer<typeof SortOrderSchema>;

const AlgoliaReviewsFacetsSchema = z.object({
  activities: AlgoliaFacet,
  feelings: AlgoliaFacet,
  rating: AlgoliaFacet,
});

export type AlgoliaReviewsFacets = z.infer<typeof AlgoliaReviewsFacetsSchema>;

const AlgoliaProductReviewSchema = z.object({
  activities: z.array(z.string()).nullish(),
  comment: z.string().nullish(),
  created_at: z.string(),
  feelings: z.array(z.string()).nullish(),
  has_comment: z.boolean(),
  hidden: z.boolean().nullish(),
  nickname: z.string(),
  objectID: z.string(),
  product_id: z.number(),
  rating: z.number(),
  upvote_count: z.number().nullish(),
});

export type AlgoliaProductReview = z.infer<typeof AlgoliaProductReviewSchema>;

export const AlgoliaProductReviewsDataSchema = z.array(
  z.object({
    facets: AlgoliaReviewsFacetsSchema,
    hits: z.array(AlgoliaProductReviewSchema),
    nbHits: z.number(),
    nbPages: z.number(),
    page: z.number(),
  })
);

export type AlgoliaProductReviewsData = z.infer<
  typeof AlgoliaProductReviewsDataSchema
>;
